import request from "../helpers/request";

export { login, loginLocationUser };

function login(email, password) {
  const auth = new Buffer(`${email}:${password}`).toString("base64");
  const authHeader = "Basic " + auth;
  return request({
    url: "cc-users/login",
    method: "POST",
    headers: { Authorization: authHeader },
  }).then((res) => {
    console.log(res);
    if (res.token) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(res.token));
      return res;
    }
  }).catch(res => { return res;});
}

function loginLocationUser(email, password) {
  const auth = new Buffer(`${email}:${password}`).toString("base64");
  const authHeader = "Basic " + auth;
  return request({
    url: "users/login",
    method: "POST",
    headers: { Authorization: authHeader },
  }).then((res) => {
    console.log(res);
    if (res.token) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(res.token));
      return res;
    }
  }).catch(res => {return res;});
}
